import { useEffect, useState } from "react";
import { Button, Card } from "@postenbring/hedwig-react";
import { ButtonWrapper } from "./ButtonWrapper";

// Keep in sync with src/main/resources/site/mixins/link-or-cta-group/index.es6 (TODO: find workaround for import)
export const LINKTYPE_CTA = "cta";

export const CTAButtonGroup = ({ buttons, inverted }) => {
    const [dataColor, setDataColor] = useState("");

    useEffect(() => {
        setDataColor(document.body?.dataset.color || "");
    }, []);

    return (
        <ButtonWrapper multiButtons={buttons.length > 1} data-color={dataColor}>
            {buttons.map((button, i) => {
                const { text, url, newTab } = button;
                const variant =
                    buttons.length === 1 && button.variant
                        ? button.variant
                        : i === 0
                          ? undefined
                          : inverted
                            ? "inverted"
                            : "secondary";
                return (
                    <Card.BodyAction key={i} asChild>
                        <Button fullWidth="mobile" variant={variant} asChild>
                            <a href={url} target={newTab ? "_blank" : "_top"} rel="noreferrer">
                                {text}
                            </a>
                        </Button>
                    </Card.BodyAction>
                );
            })}
        </ButtonWrapper>
    );
};
